import { type JSX, Show } from 'solid-js';
import { t } from '../i18n';
import { type Comparison, percent } from '../lib/radar-trends';
import { decimal } from '../lib/time';
import { AdminTrendDelta } from './AdminTrendDelta';

// One trend card on the platform radar (#6715): label, the LIVE value, and a footer
// with the change against exactly seven days ago. The whole card is the control that
// opens its 30-day chart, so it is a real `<button>` with `aria-pressed` — one card is
// selected radar-wide, and the pressed state is what a screen reader hears.
//
// No point exactly seven days back (a tier younger than a week, or a day the
// snapshot missed) reads "No 7-day comparison yet", never a delta against some
// other day.

export function AdminTrendCard(props: {
  label: string;
  value: number;
  week: Comparison;
  pressed: boolean;
  onSelect: () => void;
}): JSX.Element {
  const delta = () => (props.week.kind === 'delta' ? props.week : null);
  return (
    <button
      type="button"
      class="card admin-trend__card"
      aria-pressed={props.pressed}
      onClick={() => props.onSelect()}
    >
      <span class="admin-trend__top">
        <span class="metric-grid__label">{props.label}</span>
        <span class="metric-grid__value">{decimal(props.value)}</span>
      </span>
      <span class="admin-trend__foot">
        <Show
          when={delta()}
          fallback={<span class="admin-trend__muted">{t('admin.trend_no_week')}</span>}
        >
          {(w) => (
            <>
              <span class="admin-trend__change">
                <AdminTrendDelta delta={w().delta} tone={w().tone} />
                <span class="admin-trend__muted">{percent(w().delta, w().prev)}</span>
              </span>
              <span class="admin-trend__muted">
                {t('admin.trend_was', { value: decimal(w().prev) })}
              </span>
            </>
          )}
        </Show>
      </span>
    </button>
  );
}
